import {ClientId, NLOId} from 'notebook/ELNConstants';
import {MediocreSelection} from 'notebook/mediocre/EditorTypes';
import {NoteEditor} from 'notebook/notes/NoteEditorTypes';
import {NoteLinkedObjectType, NotePart} from 'notebook/util/NoteUtilConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export const DEFAULT_NOTE_LINKED_EMBEDDING_VIEW_HEIGHT = 393;
export const DEFAULT_NOTE_LINKED_EMBEDDING_HEADER_HEIGHT = 37;
export const DEFAULT_NOTE_LINKED_EMBEDDING_VIRTUALIZED_HEIGHT =
  DEFAULT_NOTE_LINKED_EMBEDDING_VIEW_HEIGHT + DEFAULT_NOTE_LINKED_EMBEDDING_HEADER_HEIGHT;

export type GenericNoteLinkedEmbedding<TIds> = {
  name: string;
  type: NoteLinkedObjectType.NOTE_LINKED_EMBEDDING;
} & NLOId<TIds>;
export type EmbeddingNotePart<TItem extends GenericNoteLinkedEmbedding<ClientId>> = NotePart & {
  item: TItem;
};

export interface EmbeddingProvenance {
  url: string;
  type: string;
  icon: BenchlingIconName;
}

export const cidPrefix = 'note-linked-embedding-';

export function getNoteLinkedEmbeddingCid(cid: string): string {
  return `${cidPrefix}${cid}`;
}

export function fullSelection(this: NoteEditor, notePart: NotePart): MediocreSelection {
  return {
    selection: {
      cid: getNoteLinkedEmbeddingCid(this.props.getCid(notePart)),
      start: 0,
      end: 0,
    },
  };
}
